import { Bone, Fish, PawPrint, Sparkles, Truck, ShieldCheck, Wallet } from "lucide-react";
import { useLang } from "../lib/i18n";

export default function Hero() {
  const { t } = useLang();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative pt-10 pb-16 sm:pt-16 sm:pb-24">
      <div className="absolute inset-0 dotted-bg opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
          <div className="lg:col-span-7 fade-up">
            <span
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold neo-flat"
              style={{ background: "#FDE047" }}
              data-testid="hero-badge"
            >
              <Sparkles size={14} /> {t("hero.badge")}
            </span>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight mt-5 leading-[1.05]">
              {t("hero.title1")} <span style={{ color: "var(--pm-cat)" }}>{t("hero.cat")}</span>
              {" "}{t("hero.and")}{" "}
              <span style={{ color: "var(--pm-dog)" }}>{t("hero.dog")}</span> {t("hero.title2")}
              <br />
              <span className="underline decoration-yellow-300 decoration-[10px] underline-offset-4">
                {t("hero.delivered")}
              </span>
            </h1>
            <p className="mt-5 text-base sm:text-lg text-slate-700 max-w-xl">{t("hero.subtitle")}</p>

            <div className="mt-7 flex flex-wrap gap-3">
              <button
                data-testid="hero-shop-dog-btn"
                onClick={() => scrollTo("products")}
                className="neo-btn px-5 py-3 text-white flex items-center gap-2"
                style={{ background: "var(--pm-dog)" }}
              >
                <Bone size={18} /> {t("hero.shop_dog")}
              </button>
              <button
                data-testid="hero-shop-cat-btn"
                onClick={() => scrollTo("products")}
                className="neo-btn px-5 py-3 text-white flex items-center gap-2"
                style={{ background: "var(--pm-cat)" }}
              >
                <Fish size={18} /> {t("hero.shop_cat")}
              </button>
            </div>

            <div className="mt-8 flex flex-wrap gap-5 text-sm text-slate-700">
              <span className="inline-flex items-center gap-2"><Truck size={16} /> {t("hero.fast_delivery")}</span>
              <span className="inline-flex items-center gap-2"><ShieldCheck size={16} /> {t("hero.trusted")}</span>
              <span className="inline-flex items-center gap-2"><PawPrint size={16} /> {t("hero.loved")}</span>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            <div
              className="neo-card p-6 flex flex-col items-start floaty"
              style={{ background: "var(--pm-dog)", color: "#fff" }}
              data-testid="hero-card-dog"
            >
              <Bone size={48} />
              <div className="font-display text-2xl font-bold mt-3">{t("hero.dogs_card")}</div>
              <p className="text-sm/snug opacity-90 mt-1">{t("hero.dogs_desc")}</p>
            </div>
            <div
              className="neo-card p-6 flex flex-col items-start floaty"
              style={{ background: "var(--pm-cat)", color: "#fff", animationDelay: "0.5s" }}
              data-testid="hero-card-cat"
            >
              <Fish size={48} />
              <div className="font-display text-2xl font-bold mt-3">{t("hero.cats_card")}</div>
              <p className="text-sm/snug opacity-90 mt-1">{t("hero.cats_desc")}</p>
            </div>
            <div className="neo-card p-6 col-span-2 flex items-center gap-4" data-testid="hero-card-paws">
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: "var(--pm-yellow)" }}
              >
                <Wallet size={28} />
              </div>
              <div>
                <div className="font-display text-xl font-bold">{t("hero.pay_title")}</div>
                <p className="text-sm text-slate-700">{t("hero.pay_desc")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
